(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('OfficePhoneDetailController', OfficePhoneDetailController);

    /* Added UIFormAccess
    OfficePhoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'OfficePhone'];

    function OfficePhoneDetailController($scope, $rootScope, $stateParams, previousState, entity, OfficePhone) {
    */
    OfficePhoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'OfficePhone', 'UIFormAccess'];

    function OfficePhoneDetailController($scope, $rootScope, $stateParams, previousState, entity, OfficePhone, UIFormAccess) {
        var vm = this;

        vm.officePhone = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:officePhoneUpdate', function(event, result) {
            vm.officePhone = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
